/* eslint-disable @typescript-eslint/no-namespace */
import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { WatchlistMatchType } from 'dashboard/models/report/watchlist';
import { ApiModel, ApiResource } from 'lib/interfaces/api';
import { assertNever } from 'lib/utils/types';

export enum BusinessWatchlistType {
  FitnessProbity = 'fitness-probity',
  Sanction = 'sanction',
  Warning = 'warning',
}

export function translateBusinessWatchlistType(type: BusinessWatchlistType) {
  switch (type) {
    case BusinessWatchlistType.FitnessProbity:
      return 'Fitness & Probity';
    case BusinessWatchlistType.Sanction:
      return 'Sanctions';
    case BusinessWatchlistType.Warning:
      return 'Warnings';
    default:
      assertNever(type);
  }
}

export interface ResultSource {
  name?: string;
  url?: string;
}

export interface SearchResult {
  name?: string;
  aka?: string[];
  sources?: ResultSource[];
}

export interface BusinessWatchlistIgnoreListEntry {
  'ignored-at': string;
  'run-history-completed-at': string;
  user: string;
  'ignore-reason': string;
  match: BusinessWatchlistMatch;
}

export interface BusinessWatchlistMatch {
  name?: string;
  url?: string;
  slug?: string;
  'country-code'?: string;
  'flag-code'?: string;
  'list-type'?: BusinessWatchlistType;
  entities?: BusinessWatchlistMatchEntity[];
}

export interface BusinessWatchlistMatchEntity {
  name?: string;
  'alias-type'?: WatchlistMatchType;
}

export interface ReportBusinessWatchlistAttributes extends ReportAttributes {
  'name-first'?: string;
  'name-middle'?: string;
  'name-last'?: string;
  term?: string;
  'country-code'?: string;
  'searched-lists'?: string[];
  'matched-lists'?: BusinessWatchlistMatch[];
  'ignore-list'?: BusinessWatchlistIgnoreListEntry[];
  'sanction-list'?: BusinessWatchlistMatch[];
  'warning-list'?: BusinessWatchlistMatch[];
  'fitness-probity-list'?: BusinessWatchlistMatch[];
  'searched-categories'?: BusinessWatchlistType[];
}

export type ReportBusinessWatchlist = ApiResource<
  ReportBusinessWatchlistAttributes,
  ReportRelationships,
  ApiModel.ReportBusinessWatchlist
>;
